import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useContent } from '@/hooks/useContent';

gsap.registerPlugin(ScrollTrigger);

const AppPromo = () => {
  const { t } = useContent();
  const sectionRef = useRef<HTMLDivElement>(null);
  const phoneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const phone = phoneRef.current;

    if (!section || !phone) return;

    gsap.fromTo(
      phone,
      {
        opacity: 0,
        y: 50,
        rotateY: -20,
      },
      {
        opacity: 1,
        y: 0,
        rotateY: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
        },
      }
    );

    // Continuous rotation animation
    gsap.to(phone, {
      rotateY: 10,
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
    });
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 bg-light-primary dark:bg-dark-primary"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-light-text dark:text-dark-text">
              {t('home.appPromo.title')}
            </h2>
            <p className="text-lg text-light-text-secondary dark:text-dark-text-secondary mb-8">
              {t('home.appPromo.description')}
            </p>
            <div className="flex gap-4">
              <button className="px-6 py-3 bg-brand-orange-base text-white rounded-lg hover:bg-brand-orange-light transition-colors">
                {t('home.appPromo.appStore')}
              </button>
              <button className="px-6 py-3 bg-brand-purple-base text-white rounded-lg hover:bg-brand-purple-light transition-colors">
                {t('home.appPromo.googlePlay')}
              </button>
            </div>
          </div>

          <div
            ref={phoneRef}
            className="flex justify-center perspective-1000"
            style={{ perspective: '1000px' }}
          >
            <div className="relative w-64 h-[500px] bg-gradient-to-br from-brand-purple-base via-brand-purple-dark to-brand-orange-base rounded-[3rem] p-4 shadow-2xl border border-white/20 dark:border-white/10">
              <div className="relative w-full h-full rounded-[2.5rem] overflow-hidden bg-black/5 dark:bg-white/5 shadow-inner">
                <img
                  src="/assets/images/app-login.png"
                  alt="شاشة تسجيل الدخول لتطبيق معامل الحاميلي"
                  loading="lazy"
                  draggable="false"
                  className="w-full h-full object-cover select-none pointer-events-none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromo;

